import { convertUpdateArguments } from '@angular/compiler/src/compiler_util/expression_converter';
import {AbstractControl} from '@angular/forms';
import * as moment from 'moment';
export class MyValidations {

    static isYounger(minAge: number) {
        return (control: AbstractControl) => {
            const value = control.value;
            if (value) {
              const age = moment().diff(value, 'years');
      
              if (age < minAge) {
                return { isYounger: true };
              }
            }
            
            return null;
        };
    }

    static fecHastaMenor(control: AbstractControl) {
        const hasta = control.value;
        if (hasta && control.parent != undefined ){
            const desde = control.parent.value.desde;
            if (hasta < desde){
                return {fecHastaMenor: true};
            }
        }
        return null;
    }

    static fecHastaMenor2(control: AbstractControl) {
        const hasta = control.value;
        if (hasta && control.parent != undefined ){
            const desde = control.parent.value.fechaDesde;
            if (hasta < desde){
                return {fecHastaMenor: true};
            }
        }
        return null;
    }

    static fecHastaMenor3(control: AbstractControl) {
        const hasta = control.value;
        if (hasta && control.parent != undefined ){
            const desde = control.parent.value.liquidarDesde;
            if (hasta < desde){
                return {fecHastaMenor: true};
            }
        }
        return null;
    }

    static fecHastaMenor4(control: AbstractControl) {
        const hasta = control.value;
        if (hasta && control.parent != undefined ){
            const desde = control.parent.value.inicioLiquidacion;
            if (hasta < desde){
                return {fecHastaMenor: true};
            }
        }
        return null;
    }

    static fecCompHasta(control: AbstractControl) {
        const fecha = control.value;
        if (fecha && control.parent != undefined ){
            const hasta = control.parent.value.hasta;
            if (fecha > hasta){
                return {fecCompHasta: true};
            }
        }
        return null;
    }

    //Ejemplo con parametros
    // static fecIngreso(fingreso: string) {
    //     let fede = 0;
    //     return (control: AbstractControl) => {
    //         const fecha = control.value.toDateString();
    //         if (Date.parse(fecha) < Date.parse(fingreso)){
    //             return {desdeAnterior: true};
    //         }
    //         return null;
    //     }
            
    // }
}
